"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTextForSpamLanguage = void 0;
var spamLanguage_1 = require("../consts/spamLanguage");
/**
 * Checks text if any spam language is found.
 *
 * @param text - Text to check for spam language
 * @returns Array of spam words found
 */
var checkTextForSpamLanguage = function (text) {
    // Make lower case and replace any ’ apostrophes with '
    var lowerCaseText = text.toLowerCase().replace(/’/g, '\'');
    var foundSpamPhrases = [];
    spamLanguage_1.spamLanguage.forEach(function (spamPhrase) {
        try {
            var regex = void 0;
            if (spamPhrase === '$$$') {
                regex = new RegExp(/\$\$\$/g);
            }
            else if (spamPhrase.includes('$')) {
                // This assumes all '$' symbols are at the end, which is true for now
                var escapedSpamPhrase = spamPhrase.replace(/\$/g, '\\$');
                regex = new RegExp("\\b" + escapedSpamPhrase, 'g');
            }
            else {
                regex = new RegExp("\\b" + spamPhrase + "\\b", 'g');
            }
            var match = lowerCaseText.match(regex);
            // Be sure it has a value, match sometimes returns an empty string ''
            if ((match === null || match === void 0 ? void 0 : match.length) && !!match[0]) {
                foundSpamPhrases.push(spamPhrase);
            }
        }
        catch (err) {
            console.log(err);
        }
    });
    return foundSpamPhrases;
};
exports.checkTextForSpamLanguage = checkTextForSpamLanguage;
